import React from 'react';
import './DetailedClassification.less';

export interface DetailedClassificationPropType {
    prefixCls?: string;
    secondsList?: any[]; // 二级、三级分类数据
    onItemClick?: (item) => void; // 单条点击事件
}

/**
 * 二级、三级分类组件
 * @export
 * @interface DetailedClassificationState
 */
export interface DetailedClassificationState {

}

class DetailedClassification extends React.Component<DetailedClassificationPropType, DetailedClassificationState> {
    static defaultProps = {
        prefixCls: 'detailedClassification'
    };

    render() {
        const {prefixCls, onItemClick, secondsList = []} = this.props;
        return (
            <div className={`${prefixCls}classDetailList`}>
                <div className={`${prefixCls}classDetailListInner`}>
                    {
                        secondsList && secondsList.length > 0 && secondsList.map((item, index) => {
                            return (
                                <div key={index} className={`${prefixCls}-item clearfix`}>
                                    <div className={`${prefixCls}-title`}>
                                        <div className={`${prefixCls}-titleCenter`}>                         
                                            <p>{item.name}</p>                                    
                                        </div>
                                    </div>
                                    {item.thirds && item.thirds.length > 0 && item.thirds.map((item, index) => {
                                        return (
                                            <div key={index} className={`${prefixCls}-item`} onClick={() => {
                                                onItemClick && onItemClick(item);
                                            }}>
                                                <img src={item.imgUrl}/>
                                                <p>{item.name}</p>
                                            </div>
                                        );
                                    })}

                                </div>
                            );
                        })
                    }
                </div>
            </div>

        );
    }
}

export default DetailedClassification;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/detailedClassification/DetailedClassification.tsx